import React from 'react';

function InlineQuote(props) {
  return (
    <div className="bg-os-light-blue-25 p-6 sm:pb-7 sm:px-8 rounded-lg my-8 flex">
      <div className="text-[38px] leading-[46px] text-os-blue">“</div>
      <div className="font-semibold italic mt-5">{props.children}</div>
    </div>
  );
}

export default InlineQuote;
